var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.files.length
    ? _c(
        "div",
        { attrs: { name: "documentation-settings" } },
        [
          _c(
            "carousel",
            {
              ref: "carousel",
              attrs: {
                perPage: _vm.perPage,
                navigationEnabled: true,
                mouseDrag: false,
                centerMode: true
              }
            },
            _vm._l(_vm.files, function(item) {
              return _c("slide", { key: item.id }, [
                _c("div", { staticClass: "ui header" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui small green button",
                      class: {
                        loading: _vm.showLoader && _vm.indexClicked === item.id
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadDocument(item.id, item.name)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-download" })]
                  )
                ])
              ])
            }),
            1
          )
        ],
        1
      )
    : _c("div", [
        _c("h3", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Ingen dokumenter fundet")
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e16d67e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e16d67e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profile/DocumentationSettings.vue
// module id = SQVn
// module chunks = 1